import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSent = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 140,
	height: 140,
	viewBox: "0 0 140 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M132.305 1.44091C135.344 -0.0969311 138.793 2.62548 138.001 5.93871L107.661 133.056C107.026 135.716 103.968 136.969 101.649 135.518L52.8662 105.001L130.023 7.49303L36.191 94.5696L2.87894 73.7303C0.238319 72.0786 0.415076 68.1763 3.19437 66.7701L132.305 1.44091Z",
		fill: "#26292E"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M45.7593 138.844C44.4532 140.211 42.1548 139.17 42.3213 137.286L44.5747 111.799C44.7076 110.293 46.3985 109.473 47.6631 110.302L61.2554 119.209C62.3008 119.894 62.4688 121.36 61.605 122.264L45.7593 138.844Z",
		fill: "#26292E"
	})]
});
export default SvgSent;
